var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "550pt",
    viewBox: "0 0 700 550",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff90",
    strokeWidth: 30,
    d: "m176.62 158.39c21.02 0.015625 41.184-8.3203 56.055-23.176 14.871-14.855 23.23-35.008 23.234-56.027 0.007813-21.02-8.3398-41.18-23.203-56.043-14.863-14.863-35.023-23.211-56.043-23.207-21.02 0.0078124-41.176 8.3672-56.031 23.238-14.852 14.871-23.191 35.035-23.172 56.055 0.035156 20.984 8.3867 41.098 23.223 55.938 14.84 14.836 34.953 23.188 55.938 23.223zm0-145.32c17.551-0.015625 34.391 6.9414 46.812 19.34 12.418 12.402 19.402 29.227 19.414 46.781 0.011719 17.551-6.9492 34.387-19.355 46.805-12.402 12.414-29.234 19.395-46.785 19.398-17.551 0.007812-34.383-6.9609-46.797-19.371-12.414-12.406-19.387-29.238-19.387-46.789 0.015625-17.531 6.9844-34.34 19.375-46.742s29.191-19.387 46.723-19.422z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff90",
    strokeWidth: 30,
    d: "m97.66 368.83h158.19v-158.19h-158.19zm13.062-145.13h132.07v132.07h-132.07z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff90",
    strokeWidth: 30,
    d: "m92.891 560h167.92l-83.926-145.45zm22.598-13.062 61.328-106.27 61.328 106.27z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff90",
    strokeWidth: 30,
    d: "m600.57 72.695h-285.61c-3.6094 0-6.5312 2.9219-6.5312 6.5312 0 3.6055 2.9219 6.5312 6.5312 6.5312h285.61c3.6094 0 6.5352-2.9258 6.5352-6.5312 0-3.6094-2.9258-6.5312-6.5352-6.5312z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff90",
    strokeWidth: 30,
    d: "m594.24 283.2h-285.81c-3.6094 0-6.5352 2.9258-6.5352 6.5312 0 3.6094 2.9258 6.5312 6.5352 6.5312h285.81c3.6055 0 6.5312-2.9219 6.5312-6.5312 0-3.6055-2.9258-6.5312-6.5312-6.5312z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff90",
    strokeWidth: 30,
    d: "m594.24 483.98h-285.81c-3.6094 0-6.5352 2.9219-6.5352 6.5312 0 3.6055 2.9258 6.5312 6.5352 6.5312h285.81c3.6055 0 6.5312-2.9258 6.5312-6.5312 0-3.6094-2.9258-6.5312-6.5312-6.5312z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegend);
export default __webpack_public_path__ + "static/media/legend.7c9df746c59cdecf96d7ee0d18b24723.svg";
export { ForwardRef as ReactComponent };